<div class="bk-page legacy">
<header class="bk-page__head legacy__head">
  <div class="bk-page__intro">
    <p class="bk-eyebrow">SMS</p>
    <h1 class="bk-page__title">Preview</h1>
    <p class="bk-page__sub">Check the subject, recipients and schedule. Use the edit button to go back and change anything.</p>
  </div>
</header>

<add-recipient [open]="isDraft">
  <div class="createContactForm rounded-xl">

    <div class="legacy__draft">
      <nav style="border-top-left-radius: 20px; border-top-right-radius:20px"
        class="headerdark:bg-transparent theme-border border-b px-5 py-4 flex items-center justify-between">
        <p class="!mb-0 text-lg font-semibold">Save as draft?</p>

        <!-- close -->
        <div class="closeIcon cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" (click)="closeDraft()" width="1em" height="1em" viewBox="0 0 20 20">
            <path fill="currentColor"
              d="M2.93 17.07A10 10 0 1 1 17.07 2.93A10 10 0 0 1 2.93 17.07m1.41-1.41A8 8 0 1 0 15.66 4.34A8 8 0 0 0 4.34 15.66m9.9-8.49L11.41 10l2.83 2.83l-1.41 1.41L10 11.41l-2.83 2.83l-1.41-1.41L8.59 10L5.76 7.17l1.41-1.41L10 8.59l2.83-2.83z" />
          </svg>
        </div>
      </nav>
      <div class="flex-1  p-3 mt-5">
        <img src="drafticon.svg" alt="" />
      </div>
      <div class="flex-1 mt-7 content-center flex flex-row justify-between p-4">
        <button (click)="discard()" class="bk-btn bk-btn--ghost legacy__draft-btn">Discard</button>


        <button (click)="handleDraft()" class="bk-btn bk-btn--primary legacy__draft-btn">
          @if(loading){
          <svg class="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
          </svg>
          }
          Save
        </button>



        <!-- <button (click)="handleDraft()"
          class="border p-[10px] w-[136px] border-gray-400 rounded-3xl bg-slate-950 text-white">
          @if(loading){
          <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white " xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
          </svg>
          }

          Save</button> -->

      </div>

    </div>
  </div>
</add-recipient>

<form (submit)="handleSubmit()">
  <div style="display: flex; flex-direction: column; min-height: 84vh;">
    <div class="flex flex-col flex-1">
      <div class="create-msg">
        <div style="width: 55%;">
          <div class="card bg-white dark:bg-black">
            <div class="p-5 info-card">
              <p>Preview</p>
              <!-- type="button": it must never submit the surrounding form. -->
              <button type="button" class="bk-icon-btn" aria-label="Edit message" (click)="handleEdit()">
                <span class="bk-sym" aria-hidden="true">edit</span>
              </button>
            </div>
            <div class="border header-line"></div>
            <div class="p-5">
              <div class="flex flex-col  gap-0">
                <p style="font-size: 14px; font-weight:600">Message subject</p>
                <p class="text-[#5B5B5B]" style="font-size: 14px; font-weight:400;margin-top:-8px ">{{message_subjects}}
                </p>
              </div>

              <div class="flex flex-col mt-3">
                <p style="font-size: 14px; font-weight:600">Total recipients</p>
                <p class="text-[#5B5B5B]" style="font-size: 14px; font-weight:400;margin-top:-8px ">
                  {{recipient_count}}</p>
              </div>

              <!-- <div class="flex flex-col mt-3">
                <p style="font-size: 14px; font-weight:600">Total message</p>
                <p class="text-[#5B5B5B]" style="font-size: 14px; font-weight:400;margin-top:-8px ">1</p>
              </div> -->

              <div class="flex flex-col mt-3">
                <p style="font-size: 14px; font-weight:600">Sender</p>
                <p class="text-[#5B5B5B]" style="font-size: 14px; font-weight:400;margin-top:-8px ">{{organizationName}}
                </p>
              </div>
              <div *ngIf="selectedMessageType !== 'instant' " class="flex flex-col mt-3">
                <p style="font-size: 14px; font-weight:600">Selected dates and times: </p>
                <ul style="font-size: 14px;">
                  <li>Time zone: {{selected_zone}}</li>
                  <li>Date:{{ selected_date}} , Time: {{selected_time}}</li>

                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="card legacy__phone-card flex justify-center py-4">
          <app-phone-frame>
            <div class="flex flex-col h-full legacy__screen">
              <!-- spacer for notch -->
              <div class="h-8 shrink-0"></div>
              <!-- sender ID header -->
              <div class="px-4 py-2 border-b legacy__screen-head text-center text-sm font-semibold shrink-0 truncate">
                {{ organizationName }}
              </div>
              <!-- message bubble -->
              <div class="flex-1 p-3 overflow-y-auto">
                <div class="legacy__bubble p-3 rounded-2xl text-xs max-w-[80%]">
                  {{ message?.value }}
                </div>
              </div>
            </div>
          </app-phone-frame>
        </div>
      </div>
    </div>
    <message-submit-button (submitted)="true" [loading]="loading" (cancel)="setDraft()" />

  </div>
</form>
</div>
